import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Button, Checkbox, DialogActions, FormControlLabel, Skeleton, TextField } from '@mui/material';
import CategorySelectFieldElement from '../../components/Fields/CategorySelectFieldElement';
import SelectedItemForRequest, { ISelectedItemForRequestModel } from './SelectedItemForRequest';
import NothingFound from '../../components/NothingFound';
import { ISearchParam } from '../BaseApp';
import ItemsApp, { IItemModel } from '../items/ItemsApp';
import { useDispatch } from 'react-redux';
import { handleRequestError } from '../../services/api';
import { IDataDisplayerPagination } from '../../components/DataDisplayer/DataDisplayer';
import { LoadingButton } from '@mui/lab';
import GenerateIcon from '../../components/GenerateIcon';
import BasicModalWindow from '../../components/BasicModalWIndow';
import { ItemsRequestModel } from '.';

interface ISelectItemsForRequestProps {
    show: boolean,
    handleCloseModal: () => void,
    addItems: (selectedItems: ISelectedItemForRequestModel[], doSomething?: () => void) => void,
    request?: ItemsRequestModel | null,
}

export default function SelectItemsForRequest(props: ISelectItemsForRequestProps) {

    const dispatch = useDispatch()

    const {
        show,
        addItems,
        request,
    } = props

    const itemsApp = new ItemsApp()

    const [items, setItems] = useState<ISelectedItemForRequestModel[]>([])
    const [selectedItems, setSelectedItems] = useState<ISelectedItemForRequestModel[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [search, setSearch] = useState<string>("")
    const [category, setCategory] = useState<number | null>(null)
    const [prevCategory, setPrevCategory] = useState<number | null>(null)

    const [pagination, setPagination] = useState<IDataDisplayerPagination>({
        count: 1,
        current_page: 1,
        total_pages: 1
    })

    const handleCloseModal = () => {
        props.handleCloseModal()
        setSelectedItems([])
    }

    /**
     * Handle load items
     */
    const handleLoadItems = (
        page: number, 
        search: string | null, 
        disablePagination: boolean, 
        addItems?: boolean, 
    ) => {
     
        let searchParams: ISearchParam[] = [
            {
                name: "category_id",
                value: category
            }
        ]

        setLoading(true)

        itemsApp.listOfInstances(page, search, disablePagination, addItems, searchParams)
            .then(response => {

                const { data } = response

                let itemsList: ISelectedItemForRequestModel[] = []

                if (disablePagination){

                    data.map((item: IItemModel) => {
                        itemsList.push({
                            ...item,
                            allocations: []
                        })
                    })

                    setPagination({
                        count: 1,
                        current_page: 1,
                        total_pages: 1
                    })
                }else{
                    const results: IItemModel[] = data.results

                    if (addItems){
                        itemsList = [
                            ...items
                        ]
                    }else{
                        itemsList = []
                    }
            
                    results.map((item: IItemModel) => {
                        itemsList.push({
                            ...item,
                            allocations: []
                        })
                    })
                    
                    setPagination({
                        count: data.count,
                        current_page: page,
                        total_pages: data.total_pages
                    })
                }

                setItems(itemsList)
                setLoading(false)
                setPrevCategory(category)

            })
            .catch(error => {
                handleRequestError(error, dispatch)
                setLoading(false)
            })


    }

    const handleSearch = () => handleLoadItems(1, search, false, false)

    useEffect(() => {
        if (prevCategory !== category){
            if (category){
                handleLoadItems(1, search, false, false)
            }else{
                setItems([])
            }
        }
    }, [category])

    /**
     * Render load more
     */
    const renderLoadMore = () => {
        if (pagination.total_pages === pagination.current_page){
            return <></>
        }

        return (
            <div className="load-more-button-container-selected-items-for-request">
                <div className="content-of-load-more-button-container-selected-items-for-request">
                    <LoadingButton variant="contained" className="general-button admin-style" loading={loading} startIcon={<GenerateIcon icon="refresh" />} onClick={() => handleLoadItems(pagination.current_page + 1, search ? search : "", false, true)}>
                        Load more
                    </LoadingButton>
                </div>
            </div>
        )
    }

    return(
        <BasicModalWindow
            shown={show}
            handleClose={handleCloseModal}
            size="lg"
            showHeader
            title="Select items"
            actionButtons={[
                {
                    label: "Add Items",
                    color: "success",
                    disabled: selectedItems.length > 0 ? false : true,
                    onClick: () => {
                        if (selectedItems.length === 0){
                            return;
                        }

                        let itemsList: ISelectedItemForRequestModel[] = []

                        // selectedItems.map((selectedItem) => {

                        //     const findItem = items.find((record) => record.id === selectedItem.id)
                        //     console.log("selectedItem", selectedItem)
                        //     console.log("findItem", findItem)

                        //     if (findItem){
                        //         itemsList.push(findItem)
                        //     }

                        // })

                        // addItems(itemsList)

                        addItems(selectedItems, handleCloseModal)

                    }
                },
                {
                    label: "Close",
                    color: "error",
                    onClick: handleCloseModal
                }
            ]}
            actionButtonsBottom
        >
        <div className="select-items-for-request-container">
            <div className="content-of-select-items-for-request-container">

                <div className="header-of-select-items-for-request-container grid-data-search-container">
                    <div className="content-of-header-of-select-items-for-request-container">

                        <Grid container spacing={1}>

                            <Grid size={{ xs: 6 }}>
                                <TextField
                                    variant="outlined"
                                    label="Search"
                                    value={search}
                                    onChange={((e) => setSearch(e.target.value))}
                                    fullWidth
                                    disabled={category ? false : true}
                                    onKeyUp={(e) => e.key === "Enter" && handleSearch()} 
                                />
                            </Grid>

                            <Grid size={{ xs: 4 }}>
                                <CategorySelectFieldElement 
                                    id="category"
                                    type="SelectCategory"
                                    xs={12}
                                    data={{
                                        name: "category",
                                        value: category
                                    }}
                                    handleOnChange={(id, val) => setCategory(val)}
                                    disableAddNewItem={true}
                                    selectLabel="Select Category"
                                    enableGroups={true}
                                />
                            </Grid>

                            <Grid size={{ xs: 2 }}>
                                <Button disabled={category ? false : true} className="general-button admin-button" variant="contained" fullWidth onClick={() => handleSearch()}>Search</Button>
                            </Grid>

                        </Grid>

                    </div>
                </div>

                <div className="list-of-select-items-for-request-container">
                    
                    <div className="header-of-list-of-select-items-for-request-container">
                        <div className="content-of-header-of-list-of-select-items-for-request-container">

                            <FormControlLabel control={<Checkbox checked={selectedItems.length > 0 ? true : false} onClick={(e) => {
                                if (selectedItems.length > 0){
                                    setSelectedItems([])
                                }else{

                                    let filteredItemsList: ISelectedItemForRequestModel[] = []

                                    items.map((itemInstance) => {
                                        let qnt = 0

                                        if (itemInstance.allocations.length > 0){
                                            itemInstance.allocations.map((itemAllocationInstance) => {
                                                qnt += itemAllocationInstance.quantity
                                            })
                                        }

                                        if (qnt > 0){
                                            filteredItemsList.push(itemInstance)
                                        }
                                    })

                                    setSelectedItems(filteredItemsList)
                                }
                            }} inputProps={{ 'aria-label': 'controlled' }} />} label={`Selected (${selectedItems.length})`} />

                        </div>
                    </div>

                    <div className="content-of-list-of-select-items-for-request-container">
                        
                        {!loading && items.length === 0 && <NothingFound title={category ? "Nothing..." : "Select category"} message={category ? "No items have been found." : "Please, select category first."} />}
                        
                        {items.length > 0 && items.map((item, index: number) => <SelectedItemForRequest {...item} key={index} request={request} selectedItems={selectedItems} items={items} setItems={setItems} setSelectedItems={setSelectedItems} />)}

                        {loading && (
                            <>
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10, marginTop: 10 }} />
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                            </>
                        )}

                        {renderLoadMore()}

                    </div>
                </div>

            </div>
        </div>
        </BasicModalWindow>
    )
}